import { UseQueryResult, useQuery} from 'react-query'
import request from 'superagent'
import { getApiServer } from '../../utils/domain'


interface ReleaseNote{
  version: string,
  content: string
}

export default function useReleaseNotes(): UseQueryResult<ReleaseNote[], unknown> {
  return useQuery<ReleaseNote[], unknown>('release-notes', async () => {
      const res = await request
      .get(`${getApiServer()}/release-notes`)
      .withCredentials()
      .set('Accept', 'application/json')
      return res.body
    },
    {
      staleTime: 10 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1
    }
  )
}


